/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

export { TeamTagCardContainer as TeamTagCard } from './TeamTagCard.container';
